export const capitalizeString = (text) => {
	if (typeof text !== 'string') return '';
	return text.charAt(0).toUpperCase() + text.slice(1);
};

const hostname = window.location.hostname.split('.')

export const kioskSlug = process.env.REACT_APP_KIOSK_SLUG || hostname[0] || 'Departure';
